import { connect } from "react-redux";
import DatePickerDialog from "./DatePickerDialog";
import { setDateRange, closeDatePicker } from "./actions/datepicker";

const mapStateToProps = state => {
  return {
    range: state.datepicker.range,
    visible: state.datepicker.visible
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setRange: range => {
      const { start, end } = range;
      dispatch(setDateRange({ start, end }));
    },
    close: () => dispatch(closeDatePicker())
  };
};

const DatePickerDialogContainer = connect(mapStateToProps, mapDispatchToProps)(
  DatePickerDialog
);

export default DatePickerDialogContainer;



// WEBPACK FOOTER //
// ./src/DatePickerDialogContainer.js